import { chakra, Popover as ChakraPopover, IconButton, Portal } from 'chakra-ui-next'
import * as React from 'react'
import { LuInfo, LuTriangleAlert } from 'react-icons/lu'

export interface ToggleTipProps extends ChakraPopover.RootProps {
  showArrow?: boolean
  portalled?: boolean
  portalRef?: React.RefObject<HTMLElement>
  content?: React.ReactNode
}

const InfoIcon = chakra(LuInfo)
const WarningIcon = chakra(LuTriangleAlert)

export const ToggleTip = React.forwardRef<HTMLDivElement, ToggleTipProps>(
  function ToggleTip(props, ref) {
    const { showArrow, children, portalled = true, content, portalRef, ...rest } = props

    return (
      <ChakraPopover.Root {...rest} positioning={{ ...rest.positioning, gutter: 4 }}>
        <ChakraPopover.Trigger asChild>{children}</ChakraPopover.Trigger>
        <Portal disabled={!portalled} container={portalRef}>
          <ChakraPopover.Positioner>
            <ChakraPopover.Content
              width="auto"
              px="2"
              color="fg.muted"
              py="1"
              textStyle="xs"
              rounded="lg"
              ref={ref}
            >
              {showArrow && (
                <ChakraPopover.Arrow>
                  <ChakraPopover.ArrowTip />
                </ChakraPopover.Arrow>
              )}
              {content}
            </ChakraPopover.Content>
          </ChakraPopover.Positioner>
        </Portal>
      </ChakraPopover.Root>
    )
  },
)

export const InfoTip = React.forwardRef<HTMLDivElement, Partial<ToggleTipProps>>(
  function InfoTip(props, ref) {
    const { children, ...rest } = props
    return (
      <ToggleTip content={children} {...rest} ref={ref}>
        <IconButton variant="ghost" aria-label="info" size="2xs">
          <InfoIcon color="fg.muted" />
        </IconButton>
      </ToggleTip>
    )
  },
)

export const WarningTip = React.forwardRef<HTMLDivElement, Partial<ToggleTipProps>>(
  function WarningTip(props, ref) {
    const { children, ...rest } = props
    return (
      <ToggleTip content={children} {...rest} ref={ref}>
        <IconButton variant="ghost" aria-label="warning" size="2xs" colorPalette="orange">
          <WarningIcon />
        </IconButton>
      </ToggleTip>
    )
  },
)
